export const asLink = {
  data: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.6665 10.6667H1.33331V1.33333H5.99988V0H1.33331C0.593321 0 0 0.6 0 1.33333V10.6667C0 11.4 0.593321 12 1.33331 12H10.6665C11.3998 12 11.9998 11.4 11.9998 10.6667V6H10.6665V10.6667ZM7.33318 0V1.33333H9.72647L3.17327 7.88667L4.11325 8.82667L10.6665 2.27333V4.66667H11.9998V0H7.33318Z" fill="#818F99"/>
  </svg>`,
  name: 'link',
};
